import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api.service';
import { ProfileRefreshService } from '../profile-refresh.service';

@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: ['./basic-information.component.css']
})
export class BasicInformationComponent implements OnInit {
  positionType: any = [];
  businessType: any = [];
  sportType: any = [];
  ageType: any = [];
  DOB: any;
  gender: any;
  user: any = {};
  user_Id: any;
  isLoading = false;
  saving = false;
  saveMsg = '';
  saveOk = true;
  imagePreview: string | null = null;   // naya select kiya hua photo
  currentPhoto = '';                    // server par jo photo pehle se hai

  readonly fallbackAvatar = 'assets/images/john-doe-avatar.jpg';

  constructor(private apiService: ApiService, private refresh: ProfileRefreshService) {
    this.getBusinessType();
    this.getAgeType();
    this.getSportType();
  }

  onSportTypeChange() {
    const selectedSport = this.user.sport_type;
    if (selectedSport) {
      this.getPositionType(selectedSport);
    }
  }

  getBusinessType() {
    this.apiService.getBusinessType().subscribe((response) => this.businessType = response.Categories);
  }

  getSportType() {
    this.apiService.getSportType().subscribe((response) => this.sportType = response.types);
  }

  getAgeType() {
    this.apiService.getAgeType().subscribe((response) => this.ageType = response.types);
  }

  getPositionType(sport: any) {
    this.apiService.getPositionType(sport).subscribe((response) => this.positionType = response.types);
  }

  ngOnInit(): void {
    const id = localStorage.getItem('user_id');
    if (!id) { return; }

    this.isLoading = true;
    this.apiService.getUserById(parseInt(id, 10)).subscribe(
      (response) => {
        this.gender = response.Users.gender;
        this.DOB = response.Users.DOB;
        this.user_Id = response.Users.id;
        this.currentPhoto = this.toSrc(response.Users.profile_image || response.Users.profile);

        const excludeKeys = [
          'gender', 'DOB',
          'id', 'PackageData', 'totalReffers', 'packagePrice', 'limit', 'plan_id',
          'subscription_id', 'sub_category', 'admin_text', 'balance_transaction',
          'balance_transaction_type', 'stripe_customer_id', 'stripe_subscription_id',
          'subscription_status',
          'package_id', 'refer_code', 'reffered_from', 'email_verified_at',
          'created_at', 'updated_at', 'time_zone_country', 'time_zone_time',
          'address', 'company', 'job_title', 'website', 'facebook_url',
          'twitter_url', 'linkedin_url', 'youtube_url', 'profile_image',
          'date_of_expiry', 'verification_code', 'is_verified', 'payment_id',
          'payment_method', 'user_type', 'login', 'userId', 'userid'
        ];

        const filteredUser = Object.keys(response.Users)
          .filter(key => !excludeKeys.includes(key) && response.Users[key] !== null)
          .reduce((obj, key) => {
            obj[key] = response.Users[key];
            return obj;
          }, {});

        this.user = { ...filteredUser };

        if (this.user.sport_type) {
          this.getPositionType(this.user.sport_type);
        }
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching user:', error);
        this.isLoading = false;
      }
    );
  }

  saveChanges() {
    this.saving = true;
    this.saveMsg = '';

    // original object ko ganda na karo (DOB / gender / user_id fields dobara list mein na aayen)
    const payload = { ...this.user, DOB: this.DOB, gender: this.gender, user_id: this.user_Id };

    this.apiService.updateUser(payload).subscribe(
      () => {
        this.saving = false;
        this.saveOk = true;
        this.saveMsg = 'Saved successfully';
        this.refresh.ping();
      },
      (error) => {
        console.error('Error updating user data:', error);
        this.saving = false;
        this.saveOk = false;
        this.saveMsg = 'Could not save changes';
      }
    );
  }

  /* ---------- template helpers ---------- */
  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // form mein sirf asli fields, photo ka base64 input nahi
  fieldKeys(): string[] {
    return Object.keys(this.user).filter(k => k !== 'profile_image');
  }

  formatLabel(label: string): string {
    return label.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  get photoSrc(): string {
    return this.imagePreview || this.currentPhoto || this.fallbackAvatar;
  }

  onImgError(e: any) {
    const img = e.target as HTMLImageElement;
    if (img.dataset['fb']) { return; }
    img.dataset['fb'] = '1';
    img.src = this.fallbackAvatar;
  }

  private toSrc(p: any): string {
    if (!p || typeof p !== 'string') { return ''; }
    if (p.startsWith('data:image') || p.startsWith('http')) { return p; }
    if (p.length < 300 && p.includes('/')) { return p; }          // relative path
    return 'data:image/jpeg;base64,' + p;                          // raw base64
  }

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (!file) { return; }

    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file.');
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert('Image size should be under 2MB.');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;          // preview ke liye
      this.user.profile_image = reader.result as string;    // save ke liye
    };
    reader.readAsDataURL(file);
  }
}
